// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2EOKa","options":"AnswerScale_options__2i6vr","selected":"AnswerScale_selected__2W95S"};